import {
    madnes_add_to_render,
    madnes_alpha_to, madnes_move_to,
    madnes_rem_from_render, madnes_rotate_to,
    madnes_scale_to
} from "../framework/src/engine/madnes/madnes_render";
import {
    ninestars_reel_shines,
    set_ninestars_reel_shines2_en,
    ninestars_reel_shines_en,
    set_ninestars_reel_shines_en, ninestars_reel_shines2
} from "./ninestars_reels";
import {madnes_tween_func, madnes_tween_to} from "../framework/src/engine/madnes/madnes_tween";
import {
    madnes_get_alpha,
    madnes_get_angle, madnes_get_scale_x,
    madnes_set_alpha,
    madnes_set_angle,
    madnes_set_pos,
    madnes_set_scale
} from "../framework/src/engine/madnes/madnes_object";
import {forcestop_enable, fps, he, set_forcestop_enable, wi} from "../framework/src/engine/madnes/madnes_variables";
import {madnes_audio_fade_out, madnes_audio_play} from "../framework/src/engine/madnes/madnes_audio";
import {madnes_set_text} from "../framework/src/engine/madnes/madnes_text";
import {
    madnes_add_win,
    madnes_eval, madnes_fullscreen_disable, madnes_fullscreen_enable,
    madnes_get_mouse_x,
    madnes_get_mouse_y
} from "../framework/src/engine/madnes/madnes";
import {ninestars_result_control_part_proc_nxt} from "./ninestars_core";

var autostart_timer = null;

// bonus
var ninestars_bonus_start_win_set = null;
export function ninestars_bonus_start(win_set) {
    // madnes_hide_btns();

    // madnes_win_anim_reset();

    ninestars_bonus_start_win_set = win_set;

    madnes_fullscreen_disable();

    var in_time = 1400;

    var top = 0.87;

    madnes_set_pos("bonus_background", 0, 0);
    madnes_set_alpha("bonus_background", 0);
    madnes_alpha_to("bonus_background", 1, in_time * 0.6);

    madnes_set_pos("wheel_group", wi / 2, ( he * top ) + 1000);
    madnes_move_to("wheel_group", wi / 2, he * top, in_time);
    madnes_set_angle("wheel_group", 0);

    madnes_set_pos("shines", wi / 2, ( he * top ) + 1000);
    madnes_move_to("shines", wi / 2, he * top, 1000);

    madnes_set_pos("shines2", wi / 2, ( he * top ) + 1000);
    madnes_move_to("shines2", wi / 2, he * top, 1000);

    madnes_set_pos("wheel_dark", wi / 2, ( he * top ) + 1000);
    madnes_move_to("wheel_dark", wi / 2, he * top, in_time);

    madnes_set_pos("wheel_dark_all", wi / 2, ( he * top ) + 1000);
    madnes_move_to("wheel_dark_all", wi / 2, he * top, in_time);

    madnes_set_pos("multipliers", wi / 2, ( he * top ) + 1000);
    madnes_move_to("multipliers", wi / 2, he * top, in_time);
    madnes_set_angle("multipliers", 0);

    madnes_set_pos("multiplier_dark", wi / 2, ( he * top ) + 1000);
    madnes_move_to("multiplier_dark", wi / 2, he * top, in_time);

    madnes_set_pos("multiplier_dark_all", wi / 2, ( he * top ) + 1000);
    madnes_move_to("multiplier_dark_all", wi / 2, he * top, in_time);

    madnes_set_pos("bonus_arrow", wi / 2, ( he * top ) + 1000);
    madnes_move_to("bonus_arrow", wi / 2, he * top, in_time);

    madnes_set_pos("bonus_btn_spin_disabled", wi / 2, ( he * top ) + 1000);
    madnes_move_to("bonus_btn_spin_disabled", wi / 2, he * top, in_time);

    madnes_set_pos("bonus_btn_spin", wi / 2, ( he * top ) + 1000);
    madnes_move_to("bonus_btn_spin", wi / 2, he * top, in_time);

    madnes_set_pos("bonus_btn_spin_pressed", wi / 2, ( he * top ) + 1000);
    madnes_move_to("bonus_btn_spin_pressed", wi / 2, he * top, in_time, function() {
        ninestars_bonus_middle();
        set_ninestars_reel_shines_en(1); // ninestars_reel_shines_en = 1;
        ninestars_reel_shines();
        ninestars_mystery_wheel_btn_enabled = 1;
    });

    madnes_set_pos("arrows", wi / 2, he * top);
    madnes_set_alpha("arrows", 0);
    madnes_alpha_to("arrows", 1, in_time);

    madnes_audio_play("Wheel_bg1");
    ninestars_rotated1 = 0;
    // ninestars_rotate_big_speed = 0.8;
    // ninestars_rotate_big_precision = 16 * 1;
    // ninestars_rotate_small_speed = 0.8;
    // ninestars_rotate_small_precision = 6 * 1;
    ninestars_bonus_stop1_pos = -1;
    ninestars_bonus_stop2_pos = -1;
    ninestars_rotated2 = -1;

    //ninestars_mystery_wheel_btn_enabled = 1;

    autostart_timer = setTimeout(function() {
        ninestars_rotate_start1();
        ninestars_rotate_start2();
    }, 15 * 1000);
}

function ninestars_bonus_middle()
{
    if(ninestars_rotated1 == 0)
    {
        madnes_alpha_to("bonus_btn_spin_pressed", 1, 400, ninestars_bonus_middle2);
    }
}


function ninestars_bonus_middle2()
{
    madnes_alpha_to("bonus_btn_spin_pressed", 0, 400, ninestars_bonus_middle);
}

var ninestars_mystery_wheel_btn_enabled = 0;
var ninestars_mystery_wheel_btn_enabled2 = 0;
var ninestars_mystery_wheel_startpos_x = -1;
var ninestars_mystery_wheel_startpos_y = -1;
export function ninestars_mystery_wheel_dn()
{
    if(ninestars_mystery_wheel_btn_enabled == 1)
    {
        clearTimeout(autostart_timer);
        madnes_add_to_render(ninestars_rotate_start05);

        set_ninestars_reel_shines_en(0); // ninestars_reel_shines_en = 0;
        madnes_alpha_to("arrows", 0, 1000);
        ninestars_mystery_wheel_startpos_x = madnes_get_mouse_x();
        ninestars_mystery_wheel_startpos_y = madnes_get_mouse_y();
    }
    if(ninestars_mystery_wheel_btn_enabled2 == 1)
    {
        clearTimeout(autostart_timer);
        madnes_add_to_render(ninestars_rotate_start052);

        set_ninestars_reel_shines2_en(0);
        madnes_alpha_to("arrows", 0, 1000);
        ninestars_mystery_wheel_startpos_x = madnes_get_mouse_x();
        ninestars_mystery_wheel_startpos_y = madnes_get_mouse_y();
    }
}

var ninestars_rotate_control_big_dir = 1;

export function ninestars_mystery_wheel_up()
{
    if(ninestars_mystery_wheel_btn_enabled == 1)
    {
        if(ninestars_mystery_wheel_startpos_x - madnes_get_mouse_x() < 0)
        {
            ninestars_rotate_control_big_dir = 1;
        }
        else
        {
            ninestars_rotate_control_big_dir = -1;
        }

        ninestars_rotate_start1();
        ninestars_rotate_start2();
    }
    if(ninestars_mystery_wheel_btn_enabled2 == 1)
    {
        if(ninestars_mystery_wheel_startpos_x - madnes_get_mouse_x() < 0)
        {
            ninestars_rotate_control_big_dir = 1;
        }
        else
        {
            ninestars_rotate_control_big_dir = -1;
        }

        ninestars_rotate_start1();
        ninestars_rotate_start2();
    }
}

var ninestars_rotated1 = 0;
export function ninestars_rotate_start1()
{
    ninestars_mystery_wheel_btn_enabled = 0;
    ninestars_mystery_wheel_btn_enabled2 = 0;

    set_ninestars_reel_shines2_en(0); // ninestars_reel_shines2_en = 0;
    madnes_alpha_to("arrows", 0, 250);

    if(ninestars_rotated1 == 0)
    {
        ninestars_rotated1 = 1;
    }
    if(ninestars_rotated2 == 0)
    {
        ninestars_rotated2 = 1;
    }
}

function ninestars_rotate_start05()
{
    var curr = madnes_get_mouse_x();
    var diff = curr - ninestars_mystery_wheel_startpos_x;
    madnes_set_angle("wheel_group", diff * 0.1);
}

function ninestars_rotate_start052()
{
    var curr = madnes_get_mouse_x();
    var diff = curr - ninestars_mystery_wheel_startpos_x;
    madnes_set_angle("multipliers", diff * 0.1);
}

var sinusoidal_in_out = madnes_tween_func("sinusoidal_in_out");
var sinusoidal_out = madnes_tween_func("sinusoidal_out");
function star_end1(k)
{
    var k2 = k;
    var c1 = --k2 * k2 * k2 + 1;

    var end = 0.2;

    if(k >= 1 - end)
    {
        var e = 1 - end;
        var p1 = end / 2;

        var pr = 0;

        if(k - e < p1)
        {
            pr = k - e;
        }
        else
        {
            pr = k - e;

            pr = pr - ( pr - ( p1 / 1 ) ) * 2;
        }

        pr = pr * 2;

        var X0 = 5;

        pr = sinusoidal_in_out(pr * X0) / X0;

        c1 = c1 * 1 + 0.025 * pr;
    }

    return c1;
}

function star_end2(k)
{
    var k2 = k;
    var c1 = --k2 * k2 * k2 + 1;

    var end = 0.25;

    if(k >= 1 - end)
    {
        var e = 1 - end;
        var p1 = end / 2;

        var pr = 0;

        if(k - e < p1)
        {
            pr = k - e;

            var X0 = 4;
            //pr = sinusoidal_out(pr * X0) / X0;

        }
        else
        {
            pr = k - e;

            pr = pr - ( pr - ( p1 / 1 ) ) * 2;
        }

        var X0 = 8;
        pr = sinusoidal_in_out(pr * X0) / X0;

        c1 = c1 * 1 - 0.020 * pr;
    }

    return c1;
}


var ninestart_bonus_click_pos = 0;
var ninestart_bonus_click_stepclick = 360 / 8;
var ninestars_rotate_tween_aud;
function ninestart_bonus_click()
{
    if(ninestars_rotate_tween_aud > 0)
    {
        // Zvuk / cvakání

        var curr = Math.abs(madnes_get_angle("wheel_group"));
        if(curr - ninestart_bonus_click_pos >= ninestart_bonus_click_stepclick)
        {
            ninestart_bonus_click_pos = ninestart_bonus_click_stepclick * Math.floor( curr / ninestart_bonus_click_stepclick )
            madnes_audio_play("Wheel_spin");
        }


        setTimeout(ninestart_bonus_click, 1000 / fps);
    }
}

function ninestart_bonus_click2()
{
    if(ninestars_rotate_tween_aud > 0)
    {
        // Zvuk / cvakání

        var curr = Math.abs(madnes_get_angle("multipliers"));
        if(curr - ninestart_bonus_click_pos >= ninestart_bonus_click_stepclick)
        {
            ninestart_bonus_click_pos = ninestart_bonus_click_stepclick * Math.floor( curr / ninestart_bonus_click_stepclick )
            madnes_audio_play("Wheel_spin");
        }


        setTimeout(ninestart_bonus_click2, 1000 / fps);
    }
}


var ninestars_rotate_tween = null;
export function ninestars_rotate_start2()
{
    if(ninestars_rotated1 == 1)
    {
        madnes_rem_from_render(ninestars_rotate_start05);

        setTimeout(madnes_fullscreen_enable, 100);

        ninestars_rotated1 = 2;
        madnes_alpha_to("bonus_btn_spin_pressed", 0, 800);
        madnes_alpha_to("bonus_btn_spin", 0, 800);
        set_ninestars_reel_shines_en(0); // ninestars_reel_shines_en = 0;
        if(madnes_get_alpha("arrows") == 1)
        {
            madnes_alpha_to("arrows", 0, 400);
        }
        ninestars_bonus_stop1();

        var rots = Math.ceil( Math.random() * 2 ) + 1;
        var time = rots * 3000;
        rots = rots * 360;

        if(ninestars_rotate_control_big_dir < 0)
        {
            ninestars_bonus_stop1_pos = 360 - ninestars_bonus_stop1_pos;
        }

        rots = rots * 1 + ninestars_bonus_stop1_pos * 1;

        rots = rots * ninestars_rotate_control_big_dir;



        var eas = null;
        switch(Math.floor(Math.random() * 2))
        {
            case 0:
                eas = star_end1;
                break;
            case 1:
                eas = star_end2;
                break;
            default:
                console.log("Easing 0");
                eas = star_end1;
                break;
        }

        ninestart_bonus_click_stepclick = 360 / 8;
        setTimeout(function(){
            ninestart_bonus_click_stepclick = 360 / 16;
        }, time * 0.3);

        ninestart_bonus_click_pos = 0;
        ninestars_rotate_tween_aud = 100;
        setTimeout(ninestart_bonus_click, ninestars_rotate_tween_aud);

        ninestars_rotate_tween = madnes_tween_to("wheel_group", {angle: rots}, {
                easing: eas,
                duration: time,
                callback: function() {
                    madnes_alpha_to("wheel_dark", 1, 400);
                    madnes_alpha_to("multiplier_dark_all", 0, 400);

                    ninestars_rotate_tween_aud = -9999;

                    ninestars_rotate_tween = null;

                    set_ninestars_reel_shines2_en(1); // ninestars_reel_shines2_en = 1;
                    ninestars_reel_shines2();
                    madnes_alpha_to("arrows", 1, 250);

                    madnes_fullscreen_disable();
                    ninestars_mystery_wheel_btn_enabled2 = 1;

                    madnes_alpha_to("bonus_btn_spin", 1, 400);
                    madnes_alpha_to("bonus_btn_spin_pressed", 1, 400, ninestars_bonus_middle3);
                    ninestars_rotated2 = 0;

                    madnes_audio_fade_out("Wheel_bg1", 400);
                    madnes_audio_play("Wheel_bg2");

                    autostart_timer = setTimeout(function() {
                        ninestars_rotate_start1();
                        ninestars_rotate_start2();
                    }, 15 * 1000);
                }
            }
        );

    }
    if(ninestars_rotated2 == 1)
    {
        madnes_rem_from_render(ninestars_rotate_start052);

        setTimeout(madnes_fullscreen_enable, 100);

        ninestars_rotated2 = 2;
        madnes_alpha_to("bonus_btn_spin_pressed", 0, 800);
        madnes_alpha_to("bonus_btn_spin", 0, 800);

        ninestars_bonus_stop2();


        var rots = Math.ceil( Math.random() * 2 ) + 1;
        var time = rots * 3000;
        rots = rots * 360;

        if(ninestars_rotate_control_big_dir < 0)
        {
            ninestars_bonus_stop2_pos = 360 - ninestars_bonus_stop2_pos;
        }

        rots = rots * 1 + ninestars_bonus_stop2_pos * 1;

        rots = rots * ninestars_rotate_control_big_dir;


        var eas = null;
        switch(Math.floor(Math.random() * 2))
        {
            case 0:
                eas = star_end1;
                break;
            case 1:
                eas = star_end2;
                break;
            default:
                console.log("Easing 0");
                eas = star_end1;
                break;
        }

        ninestart_bonus_click_stepclick = 360 / 6;

        ninestart_bonus_click_pos = 0;
        ninestars_rotate_tween_aud = 100;
        setTimeout(ninestart_bonus_click2, ninestars_rotate_tween_aud);

        ninestars_rotate_tween = madnes_tween_to("multipliers", {angle: rots}, {
                easing: eas,
                duration: time,
                callback: function()
                {
                    ninestars_rotate_tween = null;

                    ninestars_rotate_tween_aud = -9999;

                    madnes_alpha_to("multiplier_dark", 1, 400);
                    setTimeout(ninestars_bonus_end, 1600);
                    madnes_audio_fade_out("Wheel_bg2", 400);
                    madnes_audio_play("Wheel_bg3");
                }
            }
        );


    }
}

var ninestars_bonus_stop1_pos = -1;
function ninestars_bonus_stop1()
{
    ninestars_bonus_stop1_pos = ( 360 / 16 ) * ninestars_bonus_start_win_set.symbol;
    switch(ninestars_bonus_start_win_set.symbol)
    {
        case 0:
            ninestars_bonus_stop1_pos = 1;
            break;
        case 15:
            ninestars_bonus_stop1_pos = 24;
            break;
        case 14:
            ninestars_bonus_stop1_pos = 46;
            break;
        case 13:
            ninestars_bonus_stop1_pos = 69;
            break;
        case 12:
            ninestars_bonus_stop1_pos = 91;
            break;
        case 11:
            ninestars_bonus_stop1_pos = 114;
            break;
        case 10:
            ninestars_bonus_stop1_pos = 136;
            break;
        case 9:
            ninestars_bonus_stop1_pos = 159;
            break;
        case 8:
            ninestars_bonus_stop1_pos = 181;
            break;
        case 7:
            ninestars_bonus_stop1_pos = 203;
            break;
        case 6:
            ninestars_bonus_stop1_pos = 226;
            break;
        case 5:
            ninestars_bonus_stop1_pos = 249;
            break;
        case 4:
            ninestars_bonus_stop1_pos = 271;
            break;
        case 3:
            ninestars_bonus_stop1_pos = 294;
            break;
        case 2:
            ninestars_bonus_stop1_pos = 316;
            break;
        case 1:
            ninestars_bonus_stop1_pos = 339;
            break;
    }
}

var ninestars_rotated2 = -1;
function ninestars_bonus_middle3()
{
    if(ninestars_rotated2 == 0)
    {
        madnes_alpha_to("bonus_btn_spin_pressed", 1, 400, ninestars_bonus_middle4);
    }
}

function ninestars_bonus_middle4()
{
    madnes_alpha_to("bonus_btn_spin_pressed", 0, 400, ninestars_bonus_middle3);
}



// SMALL START

var ninestars_bonus_stop2_pos = -1;
function ninestars_bonus_stop2()
{
    ninestars_bonus_stop2_pos = 0;
    switch(ninestars_bonus_start_win_set.multiplier)
    {
        case 0: ninestars_bonus_stop2_pos = 2; break;
        case 1: ninestars_bonus_stop2_pos = 302; break;
        case 2: ninestars_bonus_stop2_pos = 243; break;
        case 3: ninestars_bonus_stop2_pos = 181; break;
        case 4: ninestars_bonus_stop2_pos = 118; break;
        case 5: ninestars_bonus_stop2_pos = 61; break;
    }
}

// SMALL END

function ninestars_bonus_end()
{
    var total_time = 2500;
    var top = 0.87;

    madnes_audio_play("Wheel_fadeout");

    madnes_alpha_to("bonus_background", 0, total_time);
    //madnes_alpha_to("bonus_sparkle", 0, total_time);
    madnes_move_to("wheel_group", wi / 2, ( he * top ) + 1000, total_time);
    madnes_move_to("multipliers", wi / 2, ( he * top ) + 1000, total_time);
    madnes_move_to("bonus_btn_spin_disabled", wi / 2, ( he * top ) + 1000, total_time);
    madnes_move_to("bonus_btn_spin_pressed", wi / 2, ( he * top ) + 1000, total_time);
    madnes_move_to("bonus_btn_spin", wi / 2, ( he * top ) + 1000, total_time);
    madnes_move_to("bonus_arrow", wi / 2, ( he * top ) + 1000, total_time);
    madnes_move_to("arrows", wi / 2, ( he * top ) + 1000, total_time, ninestars_bonus_end2);

    madnes_rotate_to("multipliers", 360 * 2, 1, total_time);
    madnes_rotate_to("wheel_group", 360 * 2, -1, total_time);

    madnes_alpha_to("multiplier_dark", 0, 200);
    madnes_alpha_to("wheel_dark", 0, 200);

}

function ninestars_bonus_end2()
{
    madnes_set_pos("bonus_background", -9999, -9999);
    //madnes_set_pos("bonus_sparkle", -9999, -9999);
    madnes_set_pos("wheel_group", -9999, -9999);
    madnes_set_pos("shines", -9999, -9999);
    madnes_set_pos("shines2", -9999, -9999);
    madnes_set_pos("multipliers", -9999, -9999);
    madnes_set_pos("bonus_btn_spin_disabled", -9999, -9999);
    madnes_set_pos("bonus_btn_spin_pressed", -9999, -9999);
    madnes_set_pos("bonus_btn_spin", -9999, -9999);
    madnes_set_pos("bonus_arrow", -9999, -9999);
    madnes_set_pos("arrows", -9999, -9999);

    // win = win * 1 + ninestars_bonus_start_win_set.win * 1;// * bet;
    madnes_add_win(ninestars_bonus_start_win_set.win * 1);

    // if(madnes_money_to_coin(win) < big_win * bet)
    // {
    // 	madnes_show_btns();
    // }

    ninestars_result_control_part_proc_nxt(ninestars_bonus_start_win_set);
}

// bonus konec



// show money
var ninestars_show_money_max = 0;
var ninestars_show_money_curr = 0;
var ninestars_show_money_callback = null;
var ninestars_show_money_pos_x = null;
var ninestars_show_money_pos_y = he * 0.44;
var forcestop_enable_tmp;

export function ninestars_show_money(money, callback)
{
    madnes_audio_play("win_Normal_Start");

    forcestop_enable_tmp = forcestop_enable;
    set_forcestop_enable(false); // forcestop_enable = false;

    ninestars_show_money_max = money;
    ninestars_show_money_curr = 0;

    if(typeof callback == "undefined")
    {
        ninestars_show_money_callback = null;
    }
    else
    {
        ninestars_show_money_callback = callback;
    }

    var moneyadd_text_pos_x = ninestars_show_money_pos_x !== null ? ninestars_show_money_pos_x : wi / 2;
    var moneyadd_text_pos_y = ninestars_show_money_pos_y !== null ? ninestars_show_money_pos_y : he / 2;

    madnes_set_text("moneyadd_text", "0");
    madnes_set_pos("moneyadd_text", moneyadd_text_pos_x, moneyadd_text_pos_y);
    madnes_set_pos("moneyadd_text_bg", moneyadd_text_pos_x, moneyadd_text_pos_y);

    ninestars_show_money_bg_control_active = 1;

    madnes_set_scale("moneyadd_text_bg", 0.01, 1);
    madnes_scale_to("moneyadd_text_bg", 0.2, 1, 50, function () {
        madnes_scale_to("moneyadd_text_bg", 1, 1, 70, ninestars_show_money_bg_control);
    });


    madnes_set_alpha("moneyadd_text", 0);
    madnes_set_alpha("moneyadd_text_bg", 0.4);

    madnes_alpha_to("moneyadd_text", 1, 40);
    madnes_alpha_to("moneyadd_text_bg", 1, 200);

    setTimeout(function() {
        madnes_add_to_render(ninestars_show_money_anim);
    }, 100);
}

var ninestars_show_money_bg_control_active = 0
function ninestars_show_money_bg_control()
{
    if(ninestars_show_money_bg_control_active == 1)
    {
        var tmp = madnes_get_scale_x("moneyadd_text_bg");
        var add = Math.random() * 0.06 + 0.01;
        if(tmp <= 1)
        {

            madnes_scale_to("moneyadd_text_bg", 1 + add, 1, 220, ninestars_show_money_bg_control);
        }
        else
        {
            madnes_scale_to("moneyadd_text_bg", 1 - add, 1, 220, ninestars_show_money_bg_control);
        }
    }
    else
    {
        madnes_scale_to("moneyadd_text_bg", 1, 1, 300, function()
        {
            setTimeout(function() {
                madnes_alpha_to("moneyadd_text", 0, 200);
                madnes_alpha_to("moneyadd_text_bg", 0, 200);

                madnes_set_scale("moneyadd_text_bg", 1, 1);
                madnes_scale_to("moneyadd_text_bg", 0.2, 1, 70, function () {
                    madnes_scale_to("moneyadd_text_bg", 0.01, 1, 50);
                });

            }, 600 - 300);

            setTimeout(function() {
                madnes_set_pos("moneyadd_text", -9999, -9999);
                madnes_set_pos("moneyadd_text_bg", -9999, -9999);
            }, 800 - 300);
        });
    }
}

var ninestars_show_money_anim_pos = 0;
var ninestars_show_money_anim_scale_from = 1;
var ninestars_show_money_anim_scale_to = 1.1;
var ninestars_show_money_anim_callback_timeout = 700;
function ninestars_show_money_anim()
{
    if(
        ninestars_show_money_anim_pos++ % 4 != 0
    )
    {
        return;
    }
    var add = Math.round( ( Math.random() / 2 ) * ninestars_show_money_max );

    if(add > ninestars_show_money_max / 20)
    {
        add = Math.round( ninestars_show_money_max / 20 );
    }

    if(add <= 0)
    {
        add = 1;
    }

    ninestars_show_money_curr = ninestars_show_money_curr * 1 + add;

    if(ninestars_show_money_curr >= ninestars_show_money_max)
    {
        madnes_audio_play("remittance_B");
        madnes_scale_to("moneyadd_text", ninestars_show_money_anim_scale_to, ninestars_show_money_anim_scale_to, 40, function() {
            madnes_scale_to("moneyadd_text", ninestars_show_money_anim_scale_from, ninestars_show_money_anim_scale_from, 200);
        });

        ninestars_show_money_curr = ninestars_show_money_max;
        madnes_set_text("moneyadd_text", ninestars_show_money_curr.toString());
        madnes_rem_from_render(ninestars_show_money_anim);

        ninestars_show_money_bg_control_active = 0;
        /*
        setTimeout(function() {
            madnes_alpha_to("moneyadd_text", 0, 200);
            madnes_alpha_to("moneyadd_text_bg", 0, 200);

            madnes_set_scale("moneyadd_text_bg", 1, 1);
            madnes_scale_to("moneyadd_text_bg", 0.2, 1, 70, function () {
                madnes_scale_to("moneyadd_text_bg", 0.01, 1, 50);
            });

        }, 600);

        setTimeout(function() {
            madnes_set_pos("moneyadd_text", -9999, -9999);
            madnes_set_pos("moneyadd_text_bg", -9999, -9999);
        }, 800);
        */

        if(ninestars_show_money_callback != null)
        {
            setTimeout(function()
                {
                    madnes_audio_play("win_Normal_End");
                    set_forcestop_enable(forcestop_enable_tmp); //forcestop_enable = forcestop_enable_tmp;
                    madnes_eval(ninestars_show_money_callback);
                },
                ninestars_show_money_anim_callback_timeout);
        }
    }
    else
    {
        madnes_audio_play("remittance_A");
        madnes_set_text("moneyadd_text", ninestars_show_money_curr.toString());
    }
}

// show money end 
